import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Form, Button, FormGroup, Modal } from 'react-bootstrap';
import config from '../../config/config';
import CoverNoteEntry from '../components/coverNotePVComponent/coverNoteEntry/CoverNoteEntry';
import ParticularOfVehicle from '../components/coverNotePVComponent/particularOfVehicle/ParticularOfVehicle';
import CoverageInfo from '../components/coverNotePVComponent/coverageInfo/CoverageInfo';
import InsuredAndDriverInfo from '../components/coverNotePVComponent/insuredAndDriverInfo/InsuredAndDriverInfo';
import ExcessDetail from '../components/coverNotePVComponent/excessDetail/ExcessDetail';
import PolicyNumberSection from '../components/coverNotePVComponent/policyNumberSection/PolicyNumberSection';
import ProgressBar from '../components/progressBar/ProgressBar';
import { numValidator } from '../utils/validator';
import { downloadPdfFile } from '../utils/utils'
import { todayMomentISOString, coverNoteTodayAdd30Day, momentToISOString, coverNoteMomentAdd30Day, momentSetHKTimezone } from '../../utils/dateUtils';

const moment = require('moment');
const async = require('async');

const appUrlPath = `/${config.appUrlPath}`;

export class CoverNotePvForm extends Component {
  constructor(props) {
    super(props);
    const role = localStorage.getItem('role');
    const agentCode = role === 'agent' ? localStorage.getItem('agentCode') : '';
    const agentName = role === 'agent' ? localStorage.getItem('displayName') : '';

    this.state = {
      redirect: false,
      validDisabled: false,
      message: [],
      showCancelModal: false,
      showModel: false,
      callSuccess: false,
      option: [],
      role,
      idNoRequired: false,
      isLoading: false,
      validSubmit: true,
      existingCoverNotes: [],
      coverNotePv: {
        coverNoteEntry: {
          agentCode,
          agentName,
          coverNoteNo: '',
          transactionType: '',
          businessType: '',
          insuredName: '',
          id: '',
          insuredType: 'individual',
          cancellationDate: null
        },
        particularOfVehicle: {
          make: '',
          model: '',
          vehicleGroup: '',
          tonnage: '',
          yearOfManufacture: '',
          vehicleRegNo: '',
          modelDesc: '',
          typeOfBody: '',
          horsePower: '',
          engineNo: '',
          chassisNo: ''
        },
        coverageInfo: {
          coveragePeriodFrom: todayMomentISOString(),
          coveragePeriodTo: coverNoteTodayAdd30Day(),
          coverType: '',
          value: ''
        },
        insuredAndDriverInfo: {
          insuredOccupation: '',
          drivingExperience: '',
          age: '',
          hirePurchaseOwner: '',
          nameDrivers: ''
        },
        excessDetail: {
          section1InsuranceOwnDamage: {
            generalExcess: '',
            theftLossExcess: '',
            parkingDamageExcess: '',
            unnamedDriverExcess: '',
            youngDriverExcess: '',
            inexperienceDriverExcess: ''
          },
          section2InsuranceThirdPartyPropertyDamage: {
            thirdPartyPropertyDamageExcess: '',
            unnamedDriverExcess: '',
            youngDriverExcess: '',
            inexperienceDriverExcess: ''
          },
          remark: '',
          policyNumber: ''
        },
        type: 'coverNotePv'
      }
    };

    this.handleChangeCoverNoteEntry = this.handleChangeCoverNoteEntry.bind(this);
    this.handleChangeParticularOfVehicle = this.handleChangeParticularOfVehicle.bind(this);
    this.handleChangeCoverageInfoPreviousFrom = this.handleChangeCoverageInfoPreviousFrom.bind(this);
    this.handleChangeCoverageInfoPreviousTo = this.handleChangeCoverageInfoPreviousTo.bind(this);
    this.handleChangeCoverageInfo = this.handleChangeCoverageInfo.bind(this)
    this.handleChangeInsuredAndDriverInfo = this.handleChangeInsuredAndDriverInfo.bind(this);
    this.handleChangeExcessDetailSection1 = this.handleChangeExcessDetailSection1.bind(this);
    this.handleChangeExcessDetailSection2 = this.handleChangeExcessDetailSection2.bind(this);
    this.handleChangeExcessDetail = this.handleChangeExcessDetail.bind(this);
    this.handleChangePolicyNumberSection = this.handleChangePolicyNumberSection.bind(this);
    this.handleGetAgentName = this.handleGetAgentName.bind(this);
    this.handleChangeAgentCode = this.handleChangeAgentCode.bind(this);

    this.handleSave = this.handleSave.bind(this);
    this.optionChange = this.optionChange.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.handleSubmitType = this.handleSubmitType.bind(this)
    this.validationOnSubmit = this.validationOnSubmit.bind(this);
    this.getExistingCoverNote = this.getExistingCoverNote.bind(this);

    this.closeCancel = this.closeCancel.bind(this);
    this.close = this.close.bind(this);
    this.cancelCoverNote = this.cancelCoverNote.bind(this);
  }

  componentWillMount() {
    // Check the access
    async.series([
      (callback) => {
        axios.get(`${appUrlPath}/getCsrfToken`, {
          params: {},
          headers: { 'ACTION-LOG': 'Access Cover Note PV Form Page' }
        })
        .then((res) => {
          axios.defaults.headers.common = {
            'CSRF-TOKEN': res.data.csrfToken
          };
          callback();
        })
        .catch(() => {
          callback();
        });
      },
      (callback) => {
        this.setState({ isLoading: true })
        callback();
      },
      (callback) => {
        const coverNoteNo = window.location.search.substr(1).split('=')[1]
        if (!coverNoteNo) {
          if (this.props.location.state && this.props.location.state.isAgree) {
            axios.get(`${appUrlPath}/generateCoverNoteNoPV`, {
              params: {}
            })
            .then((res) => {
              const coverNotePv = { ...this.state.coverNotePv };
              coverNotePv.coverNoteEntry.coverNoteNo = res.data.coverNoteNo;
              if (this.props.location.state != null) {
                const transactionType = this.props.location.state.transactionType;
                const businessType = this.props.location.state.businessType;
                if (transactionType) {
                  coverNotePv.coverNoteEntry.transactionType = transactionType
                }
                if (businessType) {
                  coverNotePv.coverNoteEntry.businessType = businessType
                }
              }

              this.setState({ coverNotePv }, () => {
                this.setState({ isLoading: false })
              });
            })
            .catch(() => {
            });
          } else {
            window.location = '/en/motorb2b/home';
          }
        } else if (this.state.role !== 'agent') {
          axios.get(`${appUrlPath}/getPVCoverNoteByNum`, {
            params: {
              coverNoteNo,
            }
          })
          .then((res) => {
            const coverNoteResult = res.data;
            if (coverNoteResult.coverageInfo.coverType === 'thirdParty') {
              this.setState({ validDisabled: true });
            }
            this.setState({ coverNotePv: coverNoteResult }, () => {
              this.setState({ isLoading: false });
              this.optionChange();
              this.getExistingCoverNote();
              this.validationOnSubmit(true);
            });
          })
          .catch(() => {
          });
        } else {
          callback(null, 'noAccess')
        }
        callback();
      }
    ], (err, result) => {
      if (result[1] === 'noAccess') {
        window.location = '/en/motorb2b/home';
      }
    });
  }

  getExistingCoverNote() {
    const coverNotePv = this.state.coverNotePv;
    const particularOfVehicle = coverNotePv.particularOfVehicle;

    axios.get(`${appUrlPath}/getExistingCoverNote`, {
      params: {
        chassisNo: particularOfVehicle.chassisNo
      }
    })
    .then((res) => {
      this.setState({ existingCoverNotes: res.data });
    })
    .catch(() => {
    });
  }

  handleChangeCoverNoteEntry(e) {
    const coverNoteEntry = { ...this.state.coverNotePv.coverNoteEntry };
    let idNoRequired = false;

    if (e.target.id === 'transactionType') {
      coverNoteEntry.transactionType = e.target.value
    } else if (e.target.id === 'insuredName') {
      coverNoteEntry.insuredName = e.target.value
    } else if (e.target.id === 'businessType') {
      coverNoteEntry.businessType = e.target.value
    } else if (e.target.id === 'insuredType') {
      coverNoteEntry.insuredType = e.target.value
      if (coverNoteEntry.insuredType === 'corporate') {
        idNoRequired = true;
      } else {
        idNoRequired = false;
      }
      this.setState({ idNoRequired }, () => { });
    } else if (e.target.id === 'idNo') {
      coverNoteEntry.id = e.target.value
    }

    this.setState({ coverNotePv: { ...this.state.coverNotePv, coverNoteEntry } });
  }

  handleChangeParticularOfVehicle(e) {
    const coverNotePv = { ...this.state.coverNotePv };
    const particularOfVehicle = coverNotePv.particularOfVehicle;
    let isMakeChange = false;
    let isModelChange = false;
    if (e.target.id === 'make') {
      particularOfVehicle.make = e.target.value;
      particularOfVehicle.model = '';
      particularOfVehicle.vehicleGroup = '';
      isMakeChange = true;
    } else if (e.target.id === 'model') {
      particularOfVehicle.model = e.target.value;
      isModelChange = true;
    } else if (e.target.id === 'tonnage') {
      if (e.target.value.length <= 40) {
        particularOfVehicle.tonnage = e.target.value;
      }
    } else if (e.target.id === 'modelDesc') {
      particularOfVehicle.modelDesc = e.target.value;
    } else if (e.target.id === 'engineNo') {
      particularOfVehicle.engineNo = e.target.value;
    } else if (e.target.id === 'yearOfManufacture') {
      if (numValidator(e.target.value)) {
        particularOfVehicle.yearOfManufacture = e.target.value;
      }
    } else if (e.target.id === 'vehicleRegNo') {
      particularOfVehicle.vehicleRegNo = e.target.value;
    } else if (e.target.id === 'chassisNo') {
      particularOfVehicle.chassisNo = e.target.value;
    } else if (e.target.id === 'typeOfBody') {
      particularOfVehicle.typeOfBody = e.target.value;
    } else if (e.target.id === 'horsePower') {
      particularOfVehicle.horsePower = e.target.value;
    }

    this.setState({ coverNotePv }, () => {
      if (isMakeChange) { this.optionChange(); }
      if (isModelChange) { this.handleVehicleGroup(); }
    });
  }

  handleChangeCoverageInfoPreviousFrom(e) {
    const coverageInfo = { ...this.state.coverNotePv.coverageInfo };
    if (e != null) {
      const isSameOrAfterToday = e.isSameOrAfter(moment(), 'day')
      if (isSameOrAfterToday) {
        coverageInfo.coveragePeriodFrom = momentToISOString(e);
        coverageInfo.coveragePeriodTo = coverNoteMomentAdd30Day(e)
      } else {
        coverageInfo.coveragePeriodFrom = todayMomentISOString()
        coverageInfo.coveragePeriodTo = null
        this.setState({ message: ['No backdate is allowed'], showModal: true });
      }
    } else {
      coverageInfo.coveragePeriodFrom = null
      coverageInfo.coveragePeriodTo = null
    }

    this.setState({ coverNotePv: { ...this.state.coverNotePv, coverageInfo } });
  }

  handleChangeCoverageInfoPreviousTo(e) {
    const coverageInfo = { ...this.state.coverNotePv.coverageInfo };

    if (e != null) {
      const isSameOrAfterToday = e.isSameOrAfter(moment(), 'day')
      const isSameOrAfterPeriodFrom = e.isSameOrAfter(coverageInfo.coveragePeriodFrom, 'day')
      if (isSameOrAfterToday && isSameOrAfterPeriodFrom) {
        coverageInfo.coveragePeriodTo = momentToISOString(e);
      } else {
        coverageInfo.coveragePeriodTo = null
        this.setState({ message: ['No backdate is allowed'], showModal: true });
      }
    } else {
      coverageInfo.coveragePeriodTo = null
    }
    this.setState({ coverNotePv: { ...this.state.coverNotePv, coverageInfo } });
  }

  handleChangeCoverageInfo(e) {
    const coverNotePv = { ...this.state.coverNotePv };
    const coverageInfo = coverNotePv.coverageInfo;

    if (e.target.id === 'coverType') {
      coverageInfo.coverType = e.target.value
      if (coverageInfo.coverType === 'thirdParty') {
        coverageInfo.value = '';
        this.setState({ validDisabled: true });
      } else {
        this.setState({ validDisabled: false });
      }
    } else if (e.target.id === 'value') {
      if (numValidator(e.target.value)) {
        coverageInfo.value = e.target.value;
      }
    }
    this.setState({ coverNotePv });
  }

  handleChangeInsuredAndDriverInfo(e) {
    const coverNotePv = { ...this.state.coverNotePv };
    const insuredAndDriverInfo = coverNotePv.insuredAndDriverInfo;

    if (e.target.id === 'insuredOccupation') {
      insuredAndDriverInfo.insuredOccupation = e.target.value
    } else if (e.target.name === 'drivingExperience') {
      insuredAndDriverInfo.drivingExperience = e.target.value;
    } else if (e.target.id === 'hirePurchaseOwner') {
      insuredAndDriverInfo.hirePurchaseOwner = e.target.value
    } else if (e.target.id === 'nameDrivers') {
      insuredAndDriverInfo.nameDrivers = e.target.value
    } else if (e.target.name === 'age') {
      insuredAndDriverInfo.age = e.target.value
    }
    this.setState({ coverNotePv });
  }

  optionChange() {
    axios.get(`${appUrlPath}/getModel`, {
      params: { 'make': this.state.coverNotePv.particularOfVehicle.make }
    })
    .then((res) => {
      this.setState({ option: res.data });
    })
    .catch(() => {
    });
  }

  handleVehicleGroup() {
    axios.get(`${appUrlPath}/getVehicleGroup`, {
      params: {
        'make': this.state.coverNotePv.particularOfVehicle.make,
        'model': this.state.coverNotePv.particularOfVehicle.model
      }
    })
    .then((res) => {
      const vehicleGroup = res.data.vehicleGroup;
      const cc = res.data.cc;
      const particularOfVehicle = { ...this.state.coverNotePv.particularOfVehicle };

      particularOfVehicle.vehicleGroup = vehicleGroup;
      particularOfVehicle.tonnage = cc;
      this.setState({ coverNotePv: { ...this.state.coverNotePv, particularOfVehicle } }, () => {
      });
    })
    .catch(() => {
    });
  }

  handleChangeExcessDetailSection1(e) {
    const coverNotePv = { ...this.state.coverNotePv };
    const section1InsuranceOwnDamage = coverNotePv.excessDetail.section1InsuranceOwnDamage

    if (e.target.id === 'generalExcess') {
      section1InsuranceOwnDamage.generalExcess = e.target.value
    } else if (e.target.id === 'theftLossExcess') {
      section1InsuranceOwnDamage.theftLossExcess = e.target.value
    } else if (e.target.id === 'parkingDamageExcess') {
      section1InsuranceOwnDamage.parkingDamageExcess = e.target.value
    } else if (e.target.id === 'unnamedDriverExcess') {
      section1InsuranceOwnDamage.unnamedDriverExcess = e.target.value
    } else if (e.target.id === 'youngDriverExcess') {
      section1InsuranceOwnDamage.youngDriverExcess = e.target.value
    } else if (e.target.id === 'inexperienceDriverExcess') {
      section1InsuranceOwnDamage.inexperienceDriverExcess = e.target.value
    }
    this.setState({ coverNotePv });
  }

  handleChangeExcessDetailSection2(e) {
    const coverNotePv = { ...this.state.coverNotePv };
    const section2InsuranceThirdPartyPropertyDamage = coverNotePv.excessDetail.section2InsuranceThirdPartyPropertyDamage

    if (e.target.id === 'thirdPartyPropertyDamageExcess') {
      section2InsuranceThirdPartyPropertyDamage.thirdPartyPropertyDamageExcess = e.target.value
    } else if (e.target.id === 'unnamedDriverExcess') {
      section2InsuranceThirdPartyPropertyDamage.unnamedDriverExcess = e.target.value
    } else if (e.target.id === 'youngDriverExcess') {
      section2InsuranceThirdPartyPropertyDamage.youngDriverExcess = e.target.value
    } else if (e.target.id === 'inexperienceDriverExcess') {
      section2InsuranceThirdPartyPropertyDamage.inexperienceDriverExcess = e.target.value
    }
    this.setState({ coverNotePv });
  }

  handleChangeExcessDetail(e) {
    const coverNotePv = { ...this.state.coverNotePv };
    if (e.target.id === 'remark') {
      coverNotePv.excessDetail.remark = e.target.value
    }
    this.setState({ coverNotePv });
  }

  handleChangePolicyNumberSection(e) {
    const coverNotePv = { ...this.state.coverNotePv };
    if (e.target.id === 'policyNumber') {
      coverNotePv.excessDetail.policyNumber = e.target.value
    }
    this.setState({ coverNotePv });
  }

  validationOnSubmit(showAlert) {
    let validSubmit = this.state.validSubmit;
    const coverNotePv = this.state.coverNotePv;
    const particularOfVehicle = coverNotePv.particularOfVehicle;

    const errorMsg = [];

    const typeArray = ['vehicleRegNo', 'drivingExperience'];

    for (let i = 0; i < typeArray.length; i++) {
      const typeValue = typeArray[i]
      if (typeValue === 'vehicleRegNo') {
        const vehicleRegNo = particularOfVehicle.vehicleRegNo;
        if (vehicleRegNo.indexOf('I') !== -1 ||
              vehicleRegNo.indexOf('O') !== -1 ||
              vehicleRegNo.indexOf('Q') !== -1 ||
              vehicleRegNo.indexOf('i') !== -1 ||
              vehicleRegNo.indexOf('o') !== -1 ||
              vehicleRegNo.indexOf('q') !== -1) {
          errorMsg.push('Invalid registration mark\n')
          validSubmit = false;
          break;
        } else {
          validSubmit = true;
        }
      } else if (typeValue === 'drivingExperience') {
        if (coverNotePv.insuredAndDriverInfo.drivingExperience !== '' && coverNotePv.insuredAndDriverInfo.drivingExperience < 2) {
          errorMsg.push('This is a referral / declined risk. Please refer to your account executive.\n')
          validSubmit = false
          break;
        } else {
          validSubmit = true
        }
      }
    }

    if (showAlert && errorMsg.length > 0) {
      this.setState({ message: errorMsg, showModal: true });
    }
    this.setState({ validSubmit });
    return validSubmit;
  }

  handleSubmitType(type) {
    if (type === 'savePrint') {
      this.setState({
        typeOfSubmit: 'savePrint'
      });
    } else if (type === 'markOffCoverNote') {
      this.setState({
        typeOfSubmit: 'markOffCoverNote'
      });
    } else if (type === 'cancelCoverNote') {
      this.setState({
        typeOfSubmit: 'cancelCoverNote'
      });
    }
  }

  handleSave(event) {
    event.preventDefault();
    if (this.state.typeOfSubmit === 'savePrint') {
      const coverNotePv = { ...this.state.coverNotePv };
      const coverageFrom = coverNotePv.coverageInfo.coveragePeriodFrom;
      if (coverageFrom) {
        const isSameOrAfterToday = momentSetHKTimezone(coverageFrom).isSameOrAfter(moment(), 'day')
        if (!isSameOrAfterToday) {
          this.setState({ message: ['Please update coverage period'], showModal: true });
          return;
        }
      }

      coverNotePv.coverNoteStatus = 'coverNoteIssued'
      // Set Create Date when it is null
      if (!coverNotePv.coverNoteEntry.createDate) {
        coverNotePv.coverNoteEntry.createDate = todayMomentISOString()
      }

      this.setState({ isLoading: true, coverNotePv }, () => {
        axios.post(`${appUrlPath}/coverNotePVSave`, {
          coverNotePv: {...this.state.coverNotePv, coverNoteStatus: 'coverNoteIssued'}
        }, { responseType: 'arraybuffer' })
        .then((response) => {
          this.setState({ isLoading: false });
          const message = `The cover note number ${this.state.coverNotePv.coverNoteEntry.coverNoteNo} is successfully saved. Please download then click OK.`;
          this.setState({ message: [message], showModal: true, callSuccess: true });

          const file = new Blob([response.data], { type: 'application/pdf' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // IE
            window.navigator.msSaveOrOpenBlob(file, 'CoverNote.pdf');
          } else {
            downloadPdfFile(file, 'CoverNote.pdf')
          }
        })
        .catch((error) => {
          let errorMsg = '';
          if (error.response) {
            errorMsg = error.response.data; 
          }
          this.setState({ isLoading: false, message: [errorMsg], showModal: true });
        });
      });
    } else if (this.state.typeOfSubmit === 'markOffCoverNote') {
      const coverNotePv = { ...this.state.coverNotePv };
      coverNotePv.coverNoteStatus = 'markedOff'
      this.setState({ coverNotePv }, () => {
        this.setState({ isLoading: true });
        axios.post(`${appUrlPath}/coverNotePVSave`, {
          coverNotePv: {...this.state.coverNotePv, coverNoteStatus: 'markedOff'}
        })
        .then(() => {
          this.setState({ isLoading: false });
          const message = `The cover note number ${this.state.coverNotePv.coverNoteEntry.coverNoteNo} is successfully saved.`;
          this.setState({ message: [message], showModal: true });
        })
        .catch((error) => {
          let errorMsg = '';
          if (error.response) {
            errorMsg = error.response.data; 
          }
          this.setState({ isLoading: false, message: [errorMsg], showModal: true });
          });
      });
    } else if (this.state.typeOfSubmit === 'cancelCoverNote') {
      this.setState({ showCancelModal: true });
    }
  }

  cancelCoverNote() {
    this.setState({ showCancelModal: false });
    const coverNotePv = { ...this.state.coverNotePv };
    coverNotePv.coverNoteStatus = 'coverNoteCancelled'
    coverNotePv.coverNoteEntry.cancellationDate = todayMomentISOString()
    this.setState({ coverNotePv }, () => {
      this.setState({ isLoading: true });
      axios.post(`${appUrlPath}/coverNotePVSave`, {
        coverNotePv: {...this.state.coverNotePv, coverNoteStatus: 'coverNoteCancelled'}
      })
      .then(() => {
        this.setState({ isLoading: false });
        const message = `The cover note number ${this.state.coverNotePv.coverNoteEntry.coverNoteNo} is successfully saved.`;
        this.setState({ message: [message], showModal: true });
      })
      .catch((error) => {
        let errorMsg = '';
        if (error.response) {
          errorMsg = error.response.data; 
        }
        this.setState({ isLoading: false, message: [errorMsg], showModal: true });
      });
    });
  }

  close() {
    this.setState({ showModal: false }, () => {
      if (this.state.callSuccess) {
        window.location.assign('/en/motorb2b/home');
      }
    });
  }

  closeCancel() {
    this.setState({ showCancelModal: false });
  }

  handleClick(e) {
    e.preventDefault();
    window.location.assign('/en/motorb2b/home');
  }

  handleChangeAgentCode(e) {
    const coverNoteEntry = { ...this.state.coverNotePv.coverNoteEntry };
    const agentCode = e.target.value;
    coverNoteEntry.agentCode = agentCode
    this.setState({ coverNotePv: { ...this.state.coverNotePv, coverNoteEntry } });
  }

  handleGetAgentName(e) {
    const coverNoteEntry = { ...this.state.coverNotePv.coverNoteEntry };
    const agentCode = e.target.value;
    axios.post(`${appUrlPath}/getAgentName`, {
      agentCode
    })
    .then((res) => {
      coverNoteEntry.agentName = res.data.agentName
      this.setState({ coverNotePv: { ...this.state.coverNotePv, coverNoteEntry } });
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (
      <div>
        {this.state.showCancelModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Cancel Cover Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
           Confirm to cancel this cover note?
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-axa" onClick={this.cancelCoverNote}>Yes</button>
            <Button onClick={this.closeCancel}>No</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}

        {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              this.state.message.map((message) => {
                return <div>{message}</div>
              })
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}

        <h3 className="ebaoUtil__HeaderTwo">New Cover Note</h3>
        <ul className="ebaoUtil__Remarks">
          <li>* Mandatory for New Cover Note</li>
          <li># Conditional Mandatory for New Cover Note</li>
        </ul>
        <Form horizontal onSubmit={this.handleSave}>
           <div className="ebaoUtil__Form-100">
              <CoverNoteEntry
                coverNoteEntry={this.state.coverNotePv.coverNoteEntry}
                handleChangeCoverNoteEntry={this.handleChangeCoverNoteEntry}
                handleGetAgentName={this.handleGetAgentName}
                handleChangeAgentCode={this.handleChangeAgentCode}
                idNoRequired={this.state.idNoRequired}
                role={this.state.role}
              />
              <ParticularOfVehicle
                particularOfVehicle={this.state.coverNotePv.particularOfVehicle}
                handleChangeParticularOfVehicle={this.handleChangeParticularOfVehicle}
                getExistingCoverNote={this.getExistingCoverNote}
                validation={this.validationOnSubmit}
                option={this.state.option}
                existingCoverNotes={this.state.existingCoverNotes}
              />
              <CoverageInfo
                coverageInfo={this.state.coverNotePv.coverageInfo}
                handleChangeCoverageInfoPreviousTo={this.handleChangeCoverageInfoPreviousTo}
                handleChangeCoverageInfoPreviousFrom={this.handleChangeCoverageInfoPreviousFrom}
                handleChangeCoverageInfo={this.handleChangeCoverageInfo}
                validDisabled={this.state.validDisabled}
              />
              <InsuredAndDriverInfo
                insuredAndDriverInfo={this.state.coverNotePv.insuredAndDriverInfo}
                handleChangeInsuredAndDriverInfo={this.handleChangeInsuredAndDriverInfo}
                validation={this.validationOnSubmit}
              />
              <ExcessDetail
                excessDetail={this.state.coverNotePv.excessDetail}
                handleChangeExcessDetailSection1={this.handleChangeExcessDetailSection1}
                handleChangeExcessDetailSection2={this.handleChangeExcessDetailSection2}
                handleChangeExcessDetail={this.handleChangeExcessDetail}
              />
              <PolicyNumberSection
                coverNotePv={this.state.coverNotePv}
                handleChangePolicyNumberSection={this.handleChangePolicyNumberSection}
              />

              <FormGroup controlId="buttonGroup">
                <div className="ebaoUtil__ButtonGroup-100">
                  { this.state.validSubmit ?
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('savePrint')} id="savePrint">Save & Print</button> :
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('savePrint')} id="savePrint" disabled>Save & Print</button>
                  }{' '}
                  { this.state.validSubmit &&
                      this.state.coverNotePv.excessDetail.policyNumber &&
                      this.state.coverNotePv.coverNoteStatus === 'coverNoteIssued' ?
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('markOffCoverNote')} id="markOffCoverNote">Mark Off Cover Note</button> :
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('markOffCoverNote')} id="markOffCoverNote" disabled>Mark Off Cover Note</button>
                  }{' '}
                  { this.state.validSubmit && this.state.role === 'admin' ?
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('cancelCoverNote')} id="cancelCoverNote">Cancel Cover Note</button> :
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('cancelCoverNote')} id="cancelCoverNote" disabled>Cancel Cover Note</button>
                  }{' '}
                  <button className="btn btn-axa" onClick={this.handleClick} type="button">Exit</button>
                </div>
              </FormGroup>
           </div>
           </Form>
      </div>

    )
  }
}

CoverNotePvForm.propTypes = {
  location: {
    state: {
      isAgree: PropTypes.bool
    }
  }
};

export default CoverNotePvForm;



// WEBPACK FOOTER //
// ./src/app/pages/CoverNotePvForm.js